module.exports = __webpack_public_path__ + "img/Residential bungalow- Kolhapur.f1d9c7c5.jpg";